import React from "react";
import { Box, Typography } from "@mui/material";

// Images
import Index1stBG from "../../assets/centrum_assets/design/index/mainBG.png";
import Bgmin from "../../assets/centrum_assets/design/index/firstBGmin.png";
import LinesDecor from "./LinesDecor";

const PageHeader = ({ title }) => {
  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      {/* ================= DESKTOP IMAGE ================= */}
     <Box
        component="img"
        src={Index1stBG}
        alt="Background Desktop"
        sx={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
          display: "block",
          mt: { xl: -8, lg: -7, md: -4 },

          "@media (max-width:1000px)": {
            display: "none",
          },
        }}
      />
      {/* ================= DESKTOP LEFT TEXT ================= */}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "5%",
          transform: "translateY(-50%)",
          width: "45%",
          zIndex: 5,

          "@media (max-width:1000px)": {
            display: "none",
          },
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          sx={{
            color: "#1b203d",
            fontWeight: 850,
             fontSize: {
              xs: "4rem",  
              sm: "5rem",  
              md: "6rem",  
              lg: "7rem",  
              xl: "9rem",  
            },
            letterSpacing: "2px",
            lineHeight: 1,
            textAlign: "left",
            marginLeft: 15
          }}
        >
          {title}
        </Typography>
      </Box>
      {/* ================= MOBILE IMAGE ================= */}
      <Box
        component="img"
        src={Bgmin}
        alt="Mobile Background"
        sx={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
          display: "none",

          "@media (max-width:1000px)": {
            display: "block",
          },
        }}
      />
      <LinesDecor
        greenMt={{ xl: -6, lg: -5, md: -4, sm: -2, xs: 1 }}
        blueMt={{ xl: -0.3, lg: 1, md: 2, sm: 1, xs: 3 }}
      />
    </Box>
  );
};

export default PageHeader;
